/**
 * Global CSS injected by the Chakra system. With MUI removed, Chakra's `preflight`
 * (enabled in system.ts) owns the document reset (box-sizing, margins, etc.); this
 * layer adds the app-wide canvas + conventions on top:
 *   - the document background + text color + body font (theme-aware via semantic vars)
 *   - selection color (brand-tinted)
 *   - font-smoothing baseline
 *   - reduced-motion convention (respects prefers-reduced-motion)
 *
 * The focus-visible ring is applied per-primitive (via `_focusVisible`), not globally.
 */
export const globalCss = {
  'html, body': {
    backgroundColor: 'var(--ehe-colors-surface-default)',
  },
  body: {
    color: 'var(--ehe-colors-text-primary)',
    fontFamily: 'var(--ehe-fonts-body)',
    minHeight: '100vh',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
  '::selection': {
    background: 'var(--ehe-colors-brand-subtle)',
    color: 'var(--ehe-colors-text-primary)',
  },
  // Reduced-motion: neutralize transitions/animations for users who ask for it.
  '@media (prefers-reduced-motion: reduce)': {
    '*, *::before, *::after': {
      animationDuration: '0.001ms !important',
      animationIterationCount: '1 !important',
      transitionDuration: '0.001ms !important',
      scrollBehavior: 'auto !important',
    },
  },
} as const;
